let language = {
    ORDER_DETAIL_ORDER_REORDER: "重新下单",
    PERSONAL_CENTER_SELECT_ALL: "全选",
    ORDER_DETAIL_SELECT: "选择",
    ORDER_DETAIL_ITEM: "项目",
    ORDER_DETAIL_PRODUCT_NAME: "产品名称",
    ORDER_DETAIL_UNIT_PRICE: "单价",
    ORDER_DETAIL_QUANTITY: "数量",
    ORDER_DETAIL_LINE_AMOUNT: "小计",
    REMODER_MODEL_ORDER_DETAIL_TOTAL: "总计",
    PERSONAL_CENTER_CANCEL: "取消",
    PERSONAL_CENTER_REODER: "下单",
    ORDER_DETAIL_DOWNLOAD_SPELLOUT_INVOICES: "下载拼单发票"
};

export { language };
 